import React from "react";

import { ISocketEmitFns } from "./types";

const emptyFn = () => undefined;

const SocketContext = React.createContext<ISocketEmitFns>({
  getQuoteFormById: emptyFn,
  offerSelected: emptyFn,
  requoteForm: emptyFn,
  saveQuoteForm: emptyFn,
  getOfferById: emptyFn
});

const useSocketContext = () => React.useContext(SocketContext);

export { SocketContext, useSocketContext };
